module.exports = __webpack_public_path__ + "img/new-aluno.5aa9c64a.jpg";